export default {
	data() {
		return {
			activeVideoTrack: null,
			activeVideoTrackNext: null
		};
	},
	computed: {		
		isVideoSupported() {
			return this.tracks.some(f => f?.type === 'video');
		}
	},
	watch: {
		
	},
	mounted() {
		
	},
	destroyed() {
		
	},
	methods: {
		calculateActiveVideoTrack() {
			if (this.isVideoSupported) {
				const tracks = this.getActiveVideoTracks();
				let activeVideoTrack = tracks && tracks[0];
				let activeVideoTrackNext = tracks && tracks[1];

				if (activeVideoTrack.start > this.currentTime) {
					activeVideoTrack = null;
				}
				if (this.activeVideoTrack !== activeVideoTrack) {
					this.activeVideoTrack = activeVideoTrack;
				}
				if (this.activeVideoTrackNext !== activeVideoTrackNext) {
					this.activeVideoTrackNext = activeVideoTrackNext;
				}
			}
		},
		getActiveVideoTracks() {
			const res = [];
			const activeTrack = this.getActiveAggregatedTrackByPlayPosition(void 0, void 0, this.tracks.filter(f => f.type === 'video'), true);
			if (activeTrack) {
				res.push(activeTrack);
				const nextTrack = this.tracks.filter(f => f.type === 'video').find(f => f.start >= activeTrack.start && f !== activeTrack);
				if (nextTrack) {
					res.push(nextTrack);
				}
			}
			return res;
		},
	}
};
